import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _contactActivity = {
    activityDate: 'google.protobuf.Timestamp',
    date: 'google.protobuf.Timestamp',
};
var _contactAddress = { address: '_address' };
var _contactAddressesWrapper = { items: '_contactAddress' };
var _contactInfo = {
    addresses: '_contactAddressesWrapper',
    picture: '_contactPicture',
};
var _contactPicture = { image: '_image' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _submitContactRequest = {
    info: '_contactInfo',
    activity: '_contactActivity',
};
var _submitContactResponse = {};
var _submitVisitorIdRequest = {};
var _submitVisitorIdResponse = { validFrom: 'google.protobuf.Timestamp' };
function resolveComWixpressContactsAllocatorApiV4ContactSubmitServiceV4Url(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/contacts/v4/contact-submit',
                destPath: '/v4/contact-submit',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/contacts/v4/contact-submit',
                destPath: '/v4/contact-submit',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/contacts/v4/contact-submit',
                destPath: '/v4/contact-submit',
            },
        ],
        _: [
            {
                srcPath: '/_api/contacts/v4/contact-submit',
                destPath: '/v4/contact-submit',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/contacts/v4/contact-submit',
                destPath: '/v4/contact-submit',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Appends an existing contact or creates a contact if it doesn't exist.
 *
 * For internal docs, see
 * [Submit Contacts](crm.contact-submit-service.introduction).
 */
export function submitContact(payload) {
    var _a = serializer(_submitContactRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _contactActivity: _contactActivity,
        _contactAddress: _contactAddress,
        _contactAddressesWrapper: _contactAddressesWrapper,
        _contactInfo: _contactInfo,
        _contactPicture: _contactPicture,
        _image: _image,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submitContactResponse, {}).fromJSON;
    function __submitContact(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.contacts.v4.submit_contact',
            method: 'POST',
            methodFqn: 'com.wixpress.contacts.allocator.api.v4.ContactSubmitServiceV4.SubmitContact',
            url: resolveComWixpressContactsAllocatorApiV4ContactSubmitServiceV4Url({
                protoPath: '/v4/contact-submit',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submitContact.fromReq = fromReq;
    __submitContact.__isAmbassador = true;
    return __submitContact;
}
/**
 * Submit visitor Id to be mapped to an existing contact Id.
 * If the visitorId already mapped to provided contactId, no action is performed
 * If no mapping exists, or visitor Id mapped to another contact Id,
 * new mapping will be created
 */
export function submitVisitorId(payload) {
    var _a = serializer(_submitVisitorIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_submitVisitorIdResponse, {}).fromJSON;
    function __submitVisitorId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.contacts.v4.submit_contact',
            method: 'POST',
            methodFqn: 'com.wixpress.contacts.allocator.api.v4.ContactSubmitServiceV4.SubmitVisitorId',
            url: resolveComWixpressContactsAllocatorApiV4ContactSubmitServiceV4Url({
                protoPath: '/v4/contact-submit/{contactId}/visitors',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __submitVisitorId.fromReq = fromReq;
    __submitVisitorId.__isAmbassador = true;
    return __submitVisitorId;
}
//# sourceMappingURL=http.impl.js.map